export default {
  nav: '/jyou-sanm-admin-test/sm', // 用于代理设置，处理本地调试时跨域
}



// WEBPACK FOOTER //
// ./src/service/index.js